import ContactPage from "../components/contactpage/contact";

export default function ContactView(){

    return (
        <ContactPage />
    )
}